export const foodInsecurityScale = {
  domain: [0, 5, 10, 15, 20, 25],
  range: ["#FED976", "#FEB24C", "#FD8D3C", "#FC4E2A", "#E31A1C"] //, "#BD0026"]
};

export const lowIncomeScale = {
  domain: [0, 1],
  range: ["#EEEEEE", "#FF00FF"]
}; 